import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	stroke: "#6D6D6D",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.54541 14L14.5454 6",
		stroke: "current",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.5454 14L6.54541 6",
		stroke: "current",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgCross;
